module.exports = __webpack_public_path__ + "static/media/facebook-black.e7d2fa89.svg";